export default __webpack_public_path__ + "static/media/stereo_08.4e98aa81.gif";